export const celeryProgressObject = {
  calculationComplete: false,
  calculationSuccessful: false,
  calculationPending: false,
  currentStep: 0,
  totalSteps: 0,
  percentComplete: 0,
  stepDescription: "",
  state: "NOT STARTED",
};
